
import { Record, Union } from "../fable_modules/fable-library-js.5.3.0/Types.js";
import { list_type, string_type, int64_type, bool_type, record_type, decimal_type, union_type } from "../fable_modules/fable-library-js.5.3.0/Reflection.js";
import { isNullOrWhiteSpace } from "../fable_modules/fable-library-js.5.3.0/String.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.5.3.0/Result.js";
import { ofArray, sumBy, exists } from "../fable_modules/fable-library-js.5.3.0/List.js";
import { op_Addition, fromParts, compare } from "../fable_modules/fable-library-js.5.3.0/Decimal.js";
import Decimal from "../fable_modules/fable-library-js.5.3.0/Decimal.js";

/**
 * Qualifying conditions a host can satisfy to release a share of the challenge fee.
 * Extending this vocabulary means adding a DU case and an evaluator arm — nothing else.
 */
export class TrancheCondition extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UpdatePosted", "PledgeReceived", "GoalReached"];
    }
}

export function TrancheCondition_$reflection() {
    return union_type("Shared.TrancheCondition", [], TrancheCondition, () => [[], [], []]);
}

export function TrancheConditionModule_toWireString(_arg) {
    switch (_arg.tag) {
        case 1:
            return "pledgeReceived";
        case 2:
            return "goalReached";
        default:
            return "updatePosted";
    }
}

export function TrancheConditionModule_ofWireString(_arg) {
    switch (_arg) {
        case "updatePosted":
            return new TrancheCondition(0, []);
        case "pledgeReceived":
            return new TrancheCondition(1, []);
        case "goalReached":
            return new TrancheCondition(2, []);
        default:
            return undefined;
    }
}

export class Tranche extends Record {
    constructor(Condition, Percentage) {
        super();
        this.Condition = Condition;
        this.Percentage = Percentage;
    }
}

export function Tranche_$reflection() {
    return record_type("Shared.Tranche", [], Tranche, () => [["Condition", TrancheCondition_$reflection()], ["Percentage", decimal_type]]);
}

/**
 * The outcome of evaluating one tranche against a host's qualifying state.
 * Lives here (pre-Challenge.fs) so the FeeShareEarned event payload can reference it;
 * it has no dependency on GoalStatus, so it moves freely ahead of the evaluator.
 */
export class TrancheResult extends Record {
    constructor(Condition, Percentage, Earned, AmountCents) {
        super();
        this.Condition = Condition;
        this.Percentage = Percentage;
        this.Earned = Earned;
        this.AmountCents = AmountCents;
    }
}

export function TrancheResult_$reflection() {
    return record_type("Shared.TrancheResult", [], TrancheResult, () => [["Condition", TrancheCondition_$reflection()], ["Percentage", decimal_type], ["Earned", bool_type], ["AmountCents", int64_type]]);
}

export class FeeShareSchedule extends Record {
    constructor(ScheduleId, Tranches) {
        super();
        this.ScheduleId = ScheduleId;
        this.Tranches = Tranches;
    }
}

export function FeeShareSchedule_$reflection() {
    return record_type("Shared.FeeShareSchedule", [], FeeShareSchedule, () => [["ScheduleId", string_type], ["Tranches", list_type(Tranche_$reflection())]]);
}

export function FeeShareScheduleModule_create(scheduleId, tranches) {
    if (isNullOrWhiteSpace(scheduleId)) {
        return new FSharpResult$2(1, ["ScheduleId must be non-empty"]);
    }
    else if (exists((t) => (compare(t.Percentage, fromParts(0, 0, 0, false, 0)) <= 0), tranches)) {
        return new FSharpResult$2(1, ["Every tranche percentage must be greater than zero"]);
    }
    else if (compare(sumBy((t_1) => t_1.Percentage, tranches, {
        GetZero: () => (new Decimal("0")),
        Add: op_Addition,
    }), fromParts(10, 0, 0, false, 1)) > 0) {
        return new FSharpResult$2(1, ["Tranche percentages must not sum above 100% of the fee"]);
    }
    else {
        return new FSharpResult$2(0, [new FeeShareSchedule(scheduleId, tranches)]);
    }
}

export const FeeShareScheduleModule_launchDefault = new FeeShareSchedule("launch-v1", ofArray([new Tranche(new TrancheCondition(0, []), fromParts(20, 0, 0, false, 2)), new Tranche(new TrancheCondition(1, []), fromParts(20, 0, 0, false, 2)), new Tranche(new TrancheCondition(2, []), fromParts(20, 0, 0, false, 2))]));

/**
 * The single lookup point where special-event schedules get registered.
 */
export function FeeShareScheduleModule_byId(scheduleId) {
    if (scheduleId === FeeShareScheduleModule_launchDefault.ScheduleId) {
        return FeeShareScheduleModule_launchDefault;
    }
    else {
        return undefined;
    }
}

//# sourceMappingURL=FeeShare.js.map
